import { PlanMyCruisePaginationProps } from '@msc-b2c/interfaces/interfaces';
import styles from './PlanMyCruisePagination.module.scss';
import { Button } from '@msc-b2c/shared-components';

export function PlanMyCruisePagination({
  totalPages,
  currentPage,
  onPageChange,
  goToFirstIcon,
  goToLastIcon,
  goToNextIcon,
  goToPrevIcon,
}: Readonly<PlanMyCruisePaginationProps>) {
  if (totalPages <= 1) {
    return null;
  }

  const getPageNumbers = () => {
    if (totalPages <= 3) return [...new Array(totalPages).keys()].map((num) => num + 1);

    if ((totalPages === 4 && currentPage > 2) || currentPage === 3) return [1, 2, 3, 4];

    if (currentPage === 1 || currentPage === 2) return [1, 2, 3];

    if (currentPage === totalPages) return [1, '...', totalPages - 2, totalPages - 1, totalPages];
    if (currentPage === totalPages - 1)
      return [1, '...', totalPages - 2, totalPages - 1, totalPages];

    return [1, '...', currentPage - 1, currentPage, currentPage + 1];
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className={styles.planMyCruisePagination}>
      <div className={styles.planMyCruisePagination__navigation}>
        <div className={styles.planMyCruisePagination__navigation__icons}>
          {goToFirstIcon && (
            <Button
              icon={goToFirstIcon}
              disabled={currentPage === 1}
              onClick={() => onPageChange(1)}
              styleOption={styles.planMyCruisePagination__navigation__icons__button}
            />
          )}
          {goToPrevIcon && (
            <Button
              icon={goToPrevIcon}
              disabled={currentPage === 1}
              onClick={() => onPageChange(currentPage - 1)}
              styleOption={styles.planMyCruisePagination__navigation__icons__button}
            />
          )}
        </div>

        {pageNumbers && pageNumbers.length > 0 && (
          <div className={styles.planMyCruisePagination__navigation__pages}>
            {pageNumbers.map((num, index) => (
              <Button
                key={`${index}-${num}`}
                text={num.toString()}
                disabled={num === '...'}
                onClick={() => onPageChange(num as number)}
                styleOption={
                  styles.planMyCruisePagination__navigation__pages__button +
                  ' ' +
                  (num === currentPage
                    ? styles.planMyCruisePagination__navigation__pages__button__active
                    : '')
                }
              />
            ))}
          </div>
        )}

        <div className={styles.planMyCruisePagination__navigation__icons}>
          {goToNextIcon && (
            <Button
              icon={goToNextIcon}
              disabled={currentPage === totalPages}
              onClick={() => onPageChange(currentPage + 1)}
              styleOption={styles.planMyCruisePagination__navigation__icons__button}
            />
          )}
          {goToLastIcon && (
            <Button
              icon={goToLastIcon}
              disabled={currentPage === totalPages}
              onClick={() => onPageChange(totalPages)}
              styleOption={styles.planMyCruisePagination__navigation__icons__button}
            />
          )}
        </div>
      </div>
    </div>
  );
}
